import React, { useEffect, useState } from "react";
import HelpPanel from "@cloudscape-design/components/help-panel";
import VariationsTable from "./components/tyre-table";
import { TyreMasterTable } from "./data";
import {
  AppLayout,
  Box,
  BreadcrumbGroup,
  ContentLayout,
  Header,
  Icon,
  Link,
  Spinner,
  SplitPanel,
} from "@cloudscape-design/components";
import { Navigation } from "../../../components/app/Navigation";
import { listTyres } from "../../../graphql/queries";
import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import { ListTyresQueryVariables } from "../../../API";

const client = generateClient();

export default function WTyreService() {
  const [activeHref, setActiveHref] = useState("/vehicles/tyres");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false);
  const [listTyre, setListTyre] = useState<TyreMasterTable[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    fetchTyre();
  }, []);

  async function fetchTyre(limit= 100) {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allTyres: TyreMasterTable[] = [];
      do {
        const variables: ListTyresQueryVariables = { limit, nextToken };
        let response = await client.graphql({
        query: listTyres,
        authMode : 'userPool',
        variables,
      });
      const tyress = response.data.listTyres.items;
      nextToken = response.data.listTyres.nextToken ?? null;  // Ensure nextToken is either string or null

      const newTyres: TyreMasterTable[] = tyress.map((tyre:any) => {
        const formattedTimestamp = new Date(tyre.updatedAt).toLocaleString();
        return {
          id: tyre["id"],
          tyreId: tyre["position"] ?? 0,
          sn: tyre["serialnumber"] ?? "",
          sensorId: tyre["sensorid"] ?? 0,
          brand: tyre["brand"] ?? "",
          typetyre: tyre["typetyre"] ?? "",
          VehicleCode: tyre["vehiclecode"] ?? "",
          pressure: tyre["pressure"] ?? 0,
          temperature: tyre["temperature"] ?? 0,
          battery: tyre["battery"] ?? 0,
          Status: Boolean(tyre["status"]),
          Timestamps: formattedTimestamp??"",
        };
      });
      allTyres = [...allTyres, ...newTyres];
      } while (nextToken);
      
      setListTyre(allTyres);
      setIsLoading(false);
      
    } catch (err) {
      console.log("error fetching todos : ", err);
    }
  }

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Vehicles",
                href: "/vehicles",
              },
              {
                text: "Tyres Summary",
                href: "/vehicles/tyres/overview",
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }}
          />
        }
        toolsOpen={helpPanelOpen}
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>
              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>
              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>
              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/vehicles/tyres" ? `Tyres Summary` : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder' style={{marginTop: isLoading ? '160px' : '0px'}}>
             
              {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading tyre data...</Box>
                </Box>
              ) : (
                <VariationsTable TyreMaster={listTyre} refreshData={fetchTyre} />
              )}
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
    </>
  );
}
